import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import type { FunctionComponent, PropsWithChildren, ReactNode } from 'react';

import { HeadlineContainerWithSidebar } from '../../../../../design/components/containers/HeadlineContainerWithSidebar';

type HistoryItemListWrapperProps = {
    readonly anchorId: string;
    readonly headline: string;
    readonly headlineActions: ReactNode;
};

export const HistoryItemListWrapper: FunctionComponent<PropsWithChildren<HistoryItemListWrapperProps>> = (props) => {
    const { anchorId, children, headline, headlineActions } = props;

    return (
        <Grid container={true} display="flex" flexDirection="column" gap={2} position="relative" width="100%">
            <Box id={anchorId} sx={{ position: 'absolute', top: -75 }} />
            <HeadlineContainerWithSidebar headline={headline}>{headlineActions}</HeadlineContainerWithSidebar>
            {children}
        </Grid>
    );
};
